// Add your custom JS here.

/**
 * Toggles the visibility of the search form when the search toggle button is clicked.
 * Also ensures the search form is closed when clicking outside of it.
 */
function setupSearchToggle() {
    const searchToggle = document.getElementById('searchToggle');
    const searchForm = document.getElementById('searchForm');

    if (!searchToggle || !searchForm) return;

    // Toggle search form visibility
    searchToggle.addEventListener('click', function () {
        if (searchForm.classList.contains('d-none')) {
            searchForm.classList.remove('d-none');
            searchForm.classList.add('show');
        } else {
            searchForm.classList.add('d-none');
            searchForm.classList.remove('show');
        }
    });

    // Close the search form if clicked outside
    document.addEventListener('click', function (event) {
        if (!searchForm.contains(event.target) && !searchToggle.contains(event.target)) {
            searchForm.classList.add('d-none');
            searchForm.classList.remove('show');
        }
    });
}

/**
 * Splits the text of elements with the class "colorhalf-text" into two halves
 * and styles each half with different spans.
 */
function styleHalfText() {
    const elements = document.querySelectorAll(".colorhalf-text");

    elements.forEach(element => {
        const textContent = element.textContent.trim(); // Get the text inside the element

        // Check if the text contains a colon
        if (textContent.includes(":")) {
            const [firstHalf, secondHalf] = textContent.split(":", 2); // Split at the first colon
            element.innerHTML = `
                <span class="half-first">${firstHalf.trim()}:</span>
                <span class="half-second">${secondHalf.trim()}</span>
            `;
        } else {
            // Fallback to midpoint splitting if no colon exists
            const words = textContent.split(" "); // Split into words
            const midpoint = Math.ceil(words.length / 2); // Find the midpoint

            // Split the text into two halves
            const firstHalf = words.slice(0, midpoint).join(" ");
            const secondHalf = words.slice(midpoint).join(" ");

            // Replace the element's content with styled spans
            element.innerHTML = `
                <span class="half-first">${firstHalf}</span>
                <span class="half-second">${secondHalf}</span>
            `;
        }
    });
}



/**
 * Sets up a "scroll to top" button functionality.
 * The button becomes visible when the user scrolls down a certain amount,
 * and smoothly scrolls to the top when clicked.
 */
function setupScrollToTop() {
    const scrollTopButton = document.getElementById("scrollTop");

    if (!scrollTopButton) {
        console.warn("Scroll to top button (ID: scrollTop) not found.");
        return;
    }

    // Show the button when the user scrolls down 100px
    window.addEventListener("scroll", function () {
        if (window.scrollY > 100) {
            scrollTopButton.style.display = "block";
        } else {
            scrollTopButton.style.display = "none";
        }
    });

    // Smoothly scroll to the top when the button is clicked
    scrollTopButton.addEventListener("click", function () {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    });
}
function setUpCountrySelect() {
        const countrySelect = document.getElementById('countrySelect');
        countrySelect.addEventListener('change', function() {
            const selectedOption = this.options[this.selectedIndex];
            const redirectUrl = selectedOption.getAttribute('data-url');
            if (redirectUrl) {
                window.location.href = redirectUrl;
            }
        });
}
/**
 * Initializes all custom JavaScript functionality when the DOM is fully loaded.
 */
function initializeCustomJS() {
    setupSearchToggle();
    styleHalfText();
    setupScrollToTop();
    setUpCountrySelect();
}

// Call all functions on DOMContentLoaded
document.addEventListener('DOMContentLoaded', initializeCustomJS);
